import _ from 'lodash';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

export default class ErrorTooltip
extends Component {
	render () {
		const { fieldKey, formStore, tooltipAt = 'top' } = this.props;
		const errorMessage = formStore.getErrorMessage(fieldKey);

		if (_.isEmpty(errorMessage)) {

			return null;
		}

		const style = {
			width: '20rem'
		};

		return (
			<span>
				<a data-tip data-for={ `${fieldKey}-err-msg` }>
					{
						<span className="fi-alert icon" style={{color:'#cc4b37'}}></span>
					}
				</a>

				<ReactTooltip id={ `${fieldKey}-err-msg` } type="error" effect="solid" place={ tooltipAt }>
					<div style={ style }>
						{ errorMessage }
					</div>
				</ReactTooltip>
			</span>
		);
	}
}
